import { Text, Badge, Spinner, makeStyles, tokens } from '@fluentui/react-components';
import { useQuery } from '@tanstack/react-query';
import { fetchLoteSystemActivity } from '../../api/lotes.api';
import { useT } from '../../i18n';

const useStyles = makeStyles({
  list: { display: 'flex', flexDirection: 'column', gap: '6px' },
  row: {
    display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 12px',
    backgroundColor: tokens.colorNeutralBackground1, borderRadius: tokens.borderRadiusMedium,
  },
});

/** Cambios de sistema del lote (nombres, zonas, geocercas), aparte de las labores de campo. */
export function LoteSystemActivity({ loteId }: { loteId: string }) {
  const s = useStyles();
  const t = useT();
  const ld = t.loteDetail as Record<string, any>;
  const { data = [], isLoading } = useQuery({
    queryKey: ['loteSystemActivity', loteId],
    queryFn: () => fetchLoteSystemActivity(loteId),
  });

  return (
    <div style={{ marginTop: 16 }}>
      <Text weight="semibold">{ld.systemTitle}</Text>
      {isLoading ? <Spinner size="small" /> : data.length === 0 ? (
        <div><Text size={200}>{ld.systemEmpty}</Text></div>
      ) : (
        <div className={s.list}>
          {data.map(i => {
            const zone = i.metadata.moduleCode ? ` ${i.metadata.moduleCode}` : '';
            const rename = i.event === 'LOTE_UPDATED' && i.metadata.previousName && i.metadata.name && i.metadata.previousName !== i.metadata.name
              ? ` (${i.metadata.previousName} → ${i.metadata.name})` : '';
            return (
              <div key={i.id} className={s.row}>
                <Badge appearance="tint" color="informative">{ld.systemEvents?.[i.event] ?? i.event}</Badge>
                <Text size={200}>
                  {(i.actorName ?? i.actor)}{zone ? ` ·${zone}` : ''}{rename} · {i.at.slice(0, 16).replace('T', ' ')}
                </Text>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
